var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0A6.031 6.031 0 0 0 .969 6.031c0 1.114.218 2.265.844 3.094L7 16l5.188-6.875c.568-.753.843-2.085.843-3.094C13.031 2.701 10.331 0 7 0Zm0 3.493A2.538 2.538 0 1 1 7 8.57a2.538 2.538 0 0 1 0-5.077Z",
    fill: "#4D76F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.0c968c94ce6aafcdea3e532d77b66d99.svg";
export { ForwardRef as ReactComponent };